import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from 'ui-components/components/flex';
import { PhoneLine } from '../read-only-fields/phone';
import { EmailLink } from '../read-only-fields/email';
import { Company } from '../read-only-fields/company';
import { Name } from '../read-only-fields/name';
import { EmptyLocation } from '../read-only-fields/empty-location';

const ReadOnlyEmptyFields = ({ style, name, company, country, phone, email }) => (
  <div className={style}>
    <Name name={name} />
    <Company company={company} />
    <EmptyLocation />
    <FlexRow>{country}</FlexRow>
    <PhoneLine phone={phone} />
    <EmailLink email={email} />
  </div>
);

ReadOnlyEmptyFields.propTypes = {
  style: PropTypes.string,
  name: PropTypes.string,
  company: PropTypes.string,
  country: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
};

export { ReadOnlyEmptyFields };
